import { render, staticRenderFns } from "./FolderDigitalAsset.vue?vue&type=template&id=0b6adc72&scoped=true"
import script from "./FolderDigitalAsset.vue?vue&type=script&lang=js"
export * from "./FolderDigitalAsset.vue?vue&type=script&lang=js"
import style0 from "./FolderDigitalAsset.vue?vue&type=style&index=0&id=0b6adc72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6adc72",
  null
  
)

export default component.exports